import { DeleteOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { CustomLink } from '../../components/CustomLink';
import DataTable from '../../components/partials/DataTable';
import PageHeader from '../../components/partials/PageHeader';
import { userRows } from '../../dummyData';

const userColumns = [
	{ field: 'id', headerName: 'ID' },
	{
		field: 'user',
		headerName: 'User',
		width: 250,
		renderCell: (params: any) => {
			return (
				<div className='flex space-x-2 items-center'>
					<img
						src={params.row.avatar}
						className='w-10 h-10 rounded-full'
						alt=''
					/>
					<span>{params.row.username}</span>
				</div>
			);
		},
	},
	{ field: 'email', headerName: 'E-mail', width: 180 },
	{ field: 'status', headerName: 'Status', width: 120 },
	{ field: 'transaction', headerName: 'Transaction', width: 120 },
	{
		field: 'action',
		headerName: 'Action',
		width: 150,
		renderCell: (params: any) => {
			return (
				<div className='w-full flex items-center justify-between'>
					<CustomLink
						to={`/users/${params.row.id}`}
						className='border-2 border-green-500 hover:bg-green-500 transition-all duration-300 text-green-900 px-5 py-2 rounded-lg'
					>
						Edit
					</CustomLink>
					<button className='hover:bg-red-200 rounded-full p-2 cursor-pointer transition-all duration-300'>
						<DeleteOutlined
							style={{ color: 'red', cursor: 'pointer' }}
						/>
					</button>
				</div>
			);
		},
	},
];
const Users = () => {
	const breadcrumbs = [
		<Link key="1" color='inherit' to='/'>
			Dashboard
		</Link>,
		<Typography key='2' color='text.primary'>
			Users
		</Typography>,
	];
	return (
		<>
			<PageHeader pageTitle='Users List' breadcrumbs={breadcrumbs}>
				<Link to='/users/create' className='button-dark w-full md:w-auto'>
					CREATE
				</Link>
			</PageHeader>

			<div className='card py-3'>
				<DataTable columns={userColumns} data={userRows} />
			</div>
		</>
	);
};

export default Users;
